import { EditableFormElements, initialEditableFormElementsState } from './editable-form-elements';
import { ConfigConstants } from '@evorait/pace-core';

// ParticipantCopyId is by v4 uuid or 'master' for the master copy
export type ParticipantCopyId = string;

export type ParticipantCopy = Readonly<{
    id: ParticipantCopyId;
    selectedInParticipantCopiesModal: boolean;
    selectedTitle: string;
    title: string;
    firstName: string;
    lastName: string;
    email: string;
    notReceivingCredit: boolean;
    signFlag: boolean; // tracks if the customer signed for the participant copy
    sortIndex: number; // to keep the order of entries in the participant copies modal
    hasCopy: boolean; // needs to set to true once a participant copy is created and the editable form elements contain real values
    submittedOn: string; // will contain the ISO Date string when the form for the copy has been submitted.
}> &
    EditableFormElements;

export type ParticipantParticulars = Pick<
    ParticipantCopy,
    | 'id'
    | 'selectedInParticipantCopiesModal'
    | 'selectedTitle'
    | 'title'
    | 'firstName'
    | 'lastName'
    | 'email'
    | 'notReceivingCredit'
>;

export const initialParticipantCopyState: ParticipantCopy = {
    id: '',
    selectedInParticipantCopiesModal: false,
    selectedTitle: ConfigConstants.attendeeTitleTechnologist,
    title: '',
    firstName: '',
    lastName: '',
    email: '',
    notReceivingCredit: false,
    signFlag: false,
    sortIndex: -1,
    hasCopy: false,
    submittedOn: '',
    ...initialEditableFormElementsState,
};
